import { Toast } from 'widgets';

import { useCreateOpportunity } from './opportunity-queries';
import { OpportunityFormOutput } from './widgets/OpportunityForm';

// Ties a new opportunity back to the note suggestion it came from: the backend marks that
// suggestion converted and useCreateOpportunity refetches the note's suggestions.
export type OpportunityLink = { suggestedOpportunityGUID?: string; noteGUID?: string };

// The one place OpportunityForm output turns into a create request. Resolves to true when created
// so the caller can close its dock item or sheet.
export const useSubmitOpportunityForm = () => {
    const createOpportunity = useCreateOpportunity();

    const submit = async (data: OpportunityFormOutput, link?: OpportunityLink): Promise<boolean> => {
        if (createOpportunity.isPending) return false;
        try {
            await createOpportunity.mutateAsync({
                householdGUID: data.prospectGUID,
                request: {
                    name: data.name,
                    description: data.description,
                    status: data.status,
                    value: data.value,
                    ...(link?.suggestedOpportunityGUID && { suggestedOpportunityGUID: link.suggestedOpportunityGUID }),
                },
                noteGUID: link?.noteGUID,
            });
            Toast.success(`Opportunity "${(data.name || 'Untitled').slice(0, 20)}" created successfully`);
            return true;
        } catch (e) {
            Toast.forError(e, 'Failed to create opportunity');
            return false;
        }
    };

    return { submit };
};
